import { Card, Grid, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@mui/styles';
import Promas from '../../icons/Promas.svg';
import TenantReportsSvg from '../../icons/tenant_reports_1.svg';
import { Link as RouterLink } from 'react-router-dom';
import { TENANTREPORTS_BASE_URL } from '../../utils/constants';


export default function IntegrationsMarketplace(props: any) {
  
  const useStyles = makeStyles({
    gridContainer: {
      background: '#FFFFFF',
      borderRadius: '24px',
    },
    btnStyle: {
      background: 'rgba(57, 162, 219, 1) !important',
      borderRadius: '24px !important',
      color: '#fff !important',
      marginRight: '12px !important',
      padding: '6px 17px !important',
      marginTop: '15px !important',
    },
    btnStyleDisabled: {
      background: 'rgba(211, 211, 211, 1) !important',
      borderRadius: '24px !important',
      color: '#fff !important',
      marginRight: '12px !important',
      padding: '6px 17px !important',
      marginTop: '15px !important',
    },
    btnStyleLight: {
      background: 'rgba(162,219,250, 1) !important',
      borderRadius: '24px !important',
      color: '#fff !important',
      marginRight: '12px !important',
      padding: '6px 17px !important',
      marginTop: '15px !important',
    },
    inputStyle: {
      borderRadius: '24px !important',
      height: '49px  !important',
      marginBottom: '16px !important',
      boxShadow: '0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important',
      outline: 'none !important',
    },
  });
  const classes = useStyles();
    
  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ p: 2, display: 'flex', flexDirection: 'column' }} className={classes.gridContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-start' }}>              
            </Grid>
            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}></Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ color: '#14142B', fontSize: '24px' }}>Accounting Integrations</Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', pb: 10 }}>
            <Grid item>
              <RouterLink to="integrations/promas">
                <img src={Promas} alt="Promas" />
              </RouterLink>
            </Grid>
            <Typography sx={{ color: '#14142B', fontSize: '14px', p: 1 }}>With more than 30 years experience with property managers and homeowner associations, we are experts in our field providing rock solid accounting software and management tools that help you run your business effectively.</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ color: '#14142B', fontSize: '24px' }}>Screening Partners <i>- Available now!</i></Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', pb: 10 }}>
            <Grid item>
              {/* <RouterLink to="integrations/tenantreports"> */}
                <img src={TenantReportsSvg} alt="Tenant Reports"
                onClick={() => {
                  window.open(`${TENANTREPORTS_BASE_URL}/inosio/`, '_blank');
                }}
                />
              {/* </RouterLink> */}
            </Grid>
            <Typography sx={{ color: '#14142B', fontSize: '14px', p: 1 }}>Our mission is to provide tenant screening solutions with the most accurate tenant reports, fastest results, supported by the best customer service in the industry at the lowest cost to our clients.</Typography>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
